/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export function Workspace1024PxIcon(props) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 28 28"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fill={"currentColor"}
        d={
          "M4.156 4.156h6.563v2.735H6.89v3.828H4.156zM6.89 21.11h3.829v2.734H4.156V17.28h2.735v3.828zM23.844 4.156v6.563h-2.735V6.89h-3.828V4.156zM21.11 17.281h2.734v6.563H17.28v-2.735h3.828v-3.828z"
        }
      ></path>
    </svg>
  );
}

export default Workspace1024PxIcon;
/* prettier-ignore-end */
